export const container = `px-4 tablet:px-5 desktop:px-9 desktop1280:px-10 max-w-desktop1440 mx-auto`;
